export default "__VITE_ASSET__CnqDG7B3__"